import * as React from "react"

const InfoCircle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="#051711"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 1.667c4.584 0 8.334 3.75 8.334 8.334 0 4.583-3.75 8.333-8.334 8.333-4.583 0-8.333-3.75-8.333-8.333 0-4.584 3.75-8.334 8.333-8.334ZM10 13.334V9.167"
    />
    <path
      stroke="#051711"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.993 6.666h.008"
    />
  </svg>
)
export default InfoCircle
